/* No commerce state is created in Phase 1. Components upgrade on editor insertion. */
document.documentElement.classList.replace('dd-no-js', 'dd-js');

// Native disclosures keep their no-JavaScript behavior. Close when focus leaves.
document.addEventListener('click', event => {
  document.querySelectorAll('.dd-navigation details[open]:not([data-cb-menu])').forEach(details => {
    if (!details.contains(event.target)) details.open = false;
  });
});
document.addEventListener('focusin', event => {
  document.querySelectorAll('.dd-navigation details[open]:not([data-cb-menu])').forEach(details => {
    if (!details.contains(event.target)) details.open = false;
  });
});
